import React from 'react';
import './PersonalScores.styles.scss';

const PersonalScores = ({ data }) => {
	const getTime = (seconds) => {
		var mins = ~~((seconds % 3600) / 60);
		var secs = ~~seconds % 60;
		return `${mins} min ${secs} sec`;
	};

	return (
		<div className="personalScores">
			<div className="sessions">
				<div className="title">Game history</div>
				<div className="head">
					<div>SCORE</div>
					<div>$ORE COLLECTED</div>
					<div>$ORE EXTRACTED</div>
					<div>PLAYTIME</div>
				</div>
				{data?.gs &&
					data.gs.map((score, index) => {
						return (
							<div className="game" key={index}>
								<div className="score">{score?.score}</div>
								<div className="score">{score?.ore_collected}</div>
								<div className="score">{score?.ore_extracted}</div>
								<div className="score">{getTime(score.seconds)}</div>
							</div>
						);
					})}
			</div>
		</div>
	);
};

export default PersonalScores;
